import * as actionTypes from '@/redux/new_store_structure/actions/actionsTypes';

const initialState = {
	loading: false,
	error: null,
	list: [],
	data: [],
};

export default function evacReplay(state = initialState, action) {
	switch (action.type) {
		// after START action set LOADING clear ERR
		case actionTypes.EVAC_REPLAY_START:
			return {
				...state,
				loading: true,
				errors: null,
			};
		// if response FAILED set ERR and clear LOADING
		case actionTypes.EVAC_REPLAY_FAILED:
			return {
				...state,
				loading: false,
				errors: action.payload.errors,
			};
		// 	SUCCEED response below:
		// 	on SUCCEED clear ERR and LOADING, set RESPONSE:
		case actionTypes.EVAC_REPLAY_LIST_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				list: action.payload,
			};
		case actionTypes.EVAC_REPLAY_DATA_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				data: action.payload,
			};
		case actionTypes.AUTH_LOGOUT:
			return initialState;
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/redux/new_store_structure/reducers/evacReplay.js